export default __webpack_public_path__ + "static/promos.url-cf4223e4f087ab9c2e1bce589cf92111.svg";